(() => {
    if (!window || !window.Shopify) return;

    const ShopifyCartURLs = [
        "/cart/add",
        "/cart/update",
        "/cart/change",
        "/cart/clear",
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
        "/cart/add.js?upcart=1&opens_cart=maybe"
    ];

    function isShopifyCartURL(url) {
        if(url instanceof URL) url = url.href;
        if(typeof url == "object" && url.url) url = url.url;
        if (!url || url.includes("app=salepify")) return false;
        
        try {
            let path = url.split("/").pop();
                path = path.split("?").shift();
            return ShopifyCartURLs.includes(`/cart/${path}`);
        } catch (e) {
            console.log("Not a normal URL: ", e)
            return false;
        }
    }

    function createAjaxCartErrorResponse (statusCode, errMessage) {
        return new Promise((resolve, reject) => {
            const response = new Response(JSON.stringify({ 
                errors: errMessage,
                description: errMessage,
                message: errMessage,
                status: statusCode
            }), {
                status: statusCode,
                headers: {
                    "Content-Type": "application/json"
                }
            });
            resolve(response);
        });
    }

    function fetchOverride() {
        if (!window.fetch || typeof window.fetch !== "function") return;
        const originalFetch = window.fetch;
        window.fetch = async function () {
            const [resource, config] = [...arguments];
            if (isShopifyCartURL(resource) && !resource.includes('add')) {
                const cartDataReq = await originalFetch('/cart.js', {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const cartDataRes = await cartDataReq.json();
                let items = JSON.parse(JSON.stringify(cartDataRes.items));
                if (items.length) {
                    const bodyArgument = JSON.parse(config.body);
                    let lineChangeIndex = null;
                    if(bodyArgument.line){
                        lineChangeIndex = Number(bodyArgument.line) - 1;
                    }else {
                        items.map((item, index) => {
                            if(item.key === bodyArgument.id){
                                lineChangeIndex =  index;
                            }
                        });
                    }
                    if (lineChangeIndex === null) {
                        return originalFetch(...arguments);
                    }
                    const itemChangeData = items[lineChangeIndex];

                    if(itemChangeData.line_price == 0) {
                        const errMessage = `You can't add more ${itemChangeData.quantity} ${itemChangeData.title} to the cart.`;
                        return createAjaxCartErrorResponse(422, errMessage)
                    }
                }
            } 
            return originalFetch(...arguments)
        };
    }

    fetchOverride();
})()